<script setup lang="ts">
import {useMediaVideoCapture} from "~/composables/studio/useMediaVideoCapture";

const {
  recordStep,
  isClosed,
  captureTransitionDurationClass,
  isRecording,
  canBeStopped,
  hasVideo,
  webcamIsActive,
  startCountdown,
  stopRecording,
  humanDuration,
  endApproaching,
} = useMediaVideoCapture()

// interface Props {}
// const props = withDefaults(defineProps<Props>(), {})

function onWebcamClick() {
  webcamIsActive.value = !webcamIsActive.value
}

function onExitClick() {
  recordStep.value = 'closed'
}
</script>

<template>
  <Transition enter-from-class="!opacity-0" leave-to-class="!opacity-0">
    <div v-if="!isClosed" class="flex gap-bento bg-black rounded-bento justify-center transition"
         :class="[captureTransitionDurationClass, {'!bg-red': isRecording}]">

      <AtomsButton :label="$t(canBeStopped ? 'capture.stop' : 'capture.record')" hover-scheme="none"
                   :before-icon="canBeStopped ? 'stop' : 'radio_button_checked'" light-color="white" dark-color="red"
                   @click="canBeStopped ? stopRecording() : startCountdown()"/>

      <AtomsButton :label="$t('capture.webcam')" v-if="hasVideo" hover-scheme="none" before-icon="video_camera_front" light-color="black"
                   dark-color="white" @click="onWebcamClick"
                   :icon-class="[webcamIsActive ? 'opacity-100' : 'opacity-25']"/>

      <AtomsButton v-if="isRecording" :label="humanDuration" hover-scheme="none" before-icon="timer" light-color="black"
                   dark-color="white" class="pointer-events-none tabular-nums" :class="{'animate-ping-small': endApproaching}"/>

      <AtomsButton v-else :label="$t('capture.exit')" hover-scheme="none" before-icon="close" light-color="black" dark-color="white"
                   @click="onExitClick"/>
    </div>
  </Transition>
</template>